import React from 'react'
import AppBar from "../../Components/header/index";
import AppProvider from "./../../Components/bootstrap"
 import AvailabilityDate from "../../Components/Pages/Authentication/AvailabilityDate"
 import {useAuthenticated} from "react-admin"
export default function Avalability() {
    useAuthenticated()
    return (
        <AppProvider>
            <AppBar/>
            <AvailabilityDate/>
           
        </AppProvider>
    );
}

